import Menu from '@mui/material/Menu'
import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { TabsSelectorOption } from './types'
import { CaretDownMinor } from '@shopify/polaris-icons'
import { colors } from 'src/theme'

interface Props<V extends string> {
  options: TabsSelectorOption<V>[]
  isOpen?: boolean
  anchorEl?: any
  menuLabel?: string
  selectedValue?: V
  onClose(): void
  onSelect: (value: V) => void
}

const TabsSelectorMenuComponent = <V extends string>({
  options,
  isOpen,
  anchorEl,
  selectedValue,
  menuLabel = 'Select',
  onClose,
  onSelect,
}: Props<V>) => {
  return (
    <Menu
      id="tabs-selector-menu"
      open={Boolean(isOpen)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div css={tw`rounded-lg bg-white w-[300px]`}>
        <div
          css={tw`pb-4 mx-4 pt-2 flex items-center border-0 border-b border-solid border-[#DAD9E0]`}
        >
          <Typography fontWeight={500} variant="subtitle1">
            {menuLabel}
          </Typography>
          <CaretDownMinor width={20} css={tw`rotate-180 ml-0.5`} />
        </div>
        {options.map(({ label, count, value }) => (
          <div
            key={label}
            css={tw`py-3 px-4 flex hover:opacity-70 cursor-pointer`}
            onClick={() => {
              onSelect(value)
              onClose()
            }}
          >
            <Typography
              css={tw`whitespace-nowrap overflow-hidden text-ellipsis`}
              fontWeight={500}
              variant="subtitle1"
              color={selectedValue !== value ? colors.SHADES_GREY_500 : undefined}
            >
              {label}
            </Typography>
            {!!count && (
              <div
                css={[
                  tw`rounded-[10px] bg-[#DAD9E0] px-2 py-0.5 ml-2`,
                  selectedValue !== value && tw`bg-[#EDEDED]`,
                ]}
              >
                <Typography
                  color={selectedValue !== value ? colors.SHADES_GREY_500 : undefined}
                  fontWeight={500}
                  variant="subtitle2"
                >
                  {count}
                </Typography>
              </div>
            )}
          </div>
        ))}
      </div>
    </Menu>
  )
}

export const TabsSelectorMenu = memo(TabsSelectorMenuComponent) as typeof TabsSelectorMenuComponent
